import './leftMenu.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { getLeftMenuData } from './leftMenuData';
import { Link, useLocation, useParams } from 'react-router-dom';
import Logout from '../../assets/icons/trvto_logout.svg';
import CollapseMenuIcon from '../../assets/icons/trvto_sidebarMenu.svg';
import ArrowBack from '../../assets/icons/trvto_closeWhite.svg';
import { SupAuthContext } from '../../context/SupAuthContext';

export default function SupLeftMenu({ showSidebar }) {
    const { mode } = useParams();
    const { SupLogoutFun } = useContext(SupAuthContext);
    const [expandSidebar, setExpandSidebar] = useState(false);
    const sidebarRef = useRef(null);
    const location = useLocation();
    const currentPath = location.pathname.split('/')[3];
    const [expandedMenus, setExpandedMenus] = useState({});
    const validModes = ['t', 'a', 'c', 'g'];
    const activeMode = validModes.includes(mode) ? mode : 't';
    const LeftMenuData = getLeftMenuData(activeMode);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setExpandSidebar(false);
            }
        };

        // Attach event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleSubmenu = (index) => {
        setExpandedMenus((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    return (
        <>
            <button
                type='button'
                onClick={() => setExpandSidebar(!expandSidebar)}
                className={`menuExpand ${expandSidebar ? 'menuExpandActive' : ''}`}
            >
                <img src={!expandSidebar ? CollapseMenuIcon : ArrowBack} alt='trvto_Close' width={24} height={24} />
            </button>
            <nav className={`nav-menu ${expandSidebar || showSidebar ? 'active' : ''}`} ref={sidebarRef}>
                <ul className='nav-menu-items'>
                    <div>
                        <li className={'nav-text show-menu'}>
                            <Link to='#' onClick={() => setExpandSidebar(!expandSidebar)}>
                                <img
                                    src={!expandSidebar ? CollapseMenuIcon : ArrowBack}
                                    alt='trvto_Close'
                                    width={30}
                                    height={30}
                                />
                            </Link>
                        </li>
                        {LeftMenuData.map((item, index) => {
                            const isActive = item.path.includes(currentPath);
                            const hasChildren = Array.isArray(item.children) && item.children.length > 0;
                            const isExpanded = expandedMenus[index];

                            return (
                                <li
                                    key={index}
                                    className={`nav-text ${isActive ? 'active' : ''} ${hasChildren ? 'has-children' : ''}`}
                                >
                                    <Link
                                        to={item.path}
                                        className='nav-link'
                                        onClick={() => {
                                            if (hasChildren) {
                                                toggleSubmenu(index);
                                            } else {
                                                localStorage.removeItem('ticketUser');
                                            }
                                        }}
                                    >
                                        <img
                                            src={isActive ? item.activeIcon : item.icon}
                                            alt={item.title}
                                            width={24}
                                            height={24}
                                        />
                                        <span className={!expandSidebar && !showSidebar ? 'nav-title' : 'show'}>
                                            {item.title}
                                        </span>
                                        {hasChildren && (
                                            <span style={{ marginLeft: 'auto' }}>
                                                <img src={item.activeIcon} alt={item.title} width={24} height={24} />
                                            </span>
                                        )}
                                    </Link>

                                    {hasChildren && isExpanded && (
                                        // <ul className='submenu'>
                                        <div className='childItems'>
                                            {item.children.map((child, childIndex) => {
                                                const childActive = child.path.includes(currentPath);
                                                return (
                                                    <li
                                                        key={childIndex}
                                                        className={`nav-sub-text ${childActive ? 'childActive' : ''}`}
                                                    >
                                                        <Link
                                                            to={child.path}
                                                            onClick={() => localStorage.removeItem('ticketUser')}
                                                            style={{ display: 'flex', gap: 20 }}
                                                        >
                                                            <img
                                                                src={childActive ? child.activeIcon : child.icon}
                                                                alt={child.title}
                                                                width={24}
                                                                height={24}
                                                            />
                                                            {child.title}
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                        </div>
                                        // </ul>
                                    )}
                                </li>
                            );
                        })}
                    </div>
                    <div>
                        <li className='nav-text'>
                            <Link onClick={() => SupLogoutFun()}>
                                <img src={Logout} alt='trvto_logout' />
                                <span className={!expandSidebar && !showSidebar ? 'nav-title' : 'show'}>Logout</span>
                            </Link>
                        </li>
                    </div>
                </ul>
            </nav>
        </>
    );
}
